import { defineComponent as t, openBlock as n, createElementBlock as o, renderSlot as r } from "vue";
const c = /* @__PURE__ */ t({
  __name: "TransitionableSlot",
  setup(l) {
    return (e, a) => (n(), o("div", null, [
      r(e.$slots, "default")
    ]));
  }
});
export {
  c as default
};
